// "Analyse video" is refused with a code in the answer's `detail` (409 while Advanced Face
// Detection is off or the document is in flight, 422 for a file that is not a video,
// 503 while video processing is temporarily disabled); this
// helper lets the document list say why in the reader's language. Pure: no IO.
import type { TFunction } from 'i18next'
import { detailCode } from '@/features/humint/mappers/errors'
import { ApiError } from '@/services/api/client'

/** The refusal codes the server sends, each with its sentence under `documents.video.refusals`. */
const REFUSAL_CODES = new Set([
  'video_analysis_unavailable',
  'document_in_flight',
  'not_a_video',
  'video_too_large',
])

/** The sentence for a refusal code the server sends; null for a code that is none. */
export function videoRefusalText(code: unknown, t: TFunction): string | null {
  if (code === 'video_temporarily_unavailable') return t('documents.video.temporarilyUnavailable')
  return typeof code === 'string' && REFUSAL_CODES.has(code)
    ? t(`documents.video.refusals.${code}`)
    : null
}

/** The translated reason the analysis was refused; null for any other failure. */
export function videoAnalysisRefusal(error: unknown, t: TFunction): string | null {
  if (!(error instanceof ApiError)) return null
  const code = detailCode(error)
  if (error.status === 503 && code === 'video_temporarily_unavailable')
    return videoRefusalText(code, t)
  return error.status === 409 || error.status === 422 ? videoRefusalText(code, t) : null
}
